import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import { AiOutlineClose } from "react-icons/ai";
import AuthModal from "../../components/modals/AuthModal/AuthModal";
import UserProfile from "../../assets/images/user-profile.webp";
import axios from "axios";
import config from "../../config";
import { Button } from "@mui/material";
import messages from "../../assets/images/profile-messages.svg";
import dashboard from "../../assets/images/hugeicons_dashboard-square-edit.svg";
import Favourite from "../../assets/images/fav-Icon.svg";
import myKitchen from "../../assets/images/My Kitchenz Icon.svg";
import booking from "../../assets/images/Booking.svg";
import settings from "../../assets/images/Setting Icon.svg";
import Sign_Out from "../../assets/images/SignOut.svg";
import "./Navbar.css";

const Navbar = () => {
  const { user, logout } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState("login");
  const [orders, setOrders] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1025);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        if (user && user.userID) {
          const userID = user.userID;
          const res = await axios.get(
            `${config.apiBaseUrl}/api/restaurants/foodorders/${userID}`,
            {
              params: { userID },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }
          );
          setOrders(res.data || []);
        }
      } catch (error) {
        console.error("Error fetching food orders:", error);
      }
    };
    fetchOrders();
  }, [user]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleProfileMenu = () => {
    setProfileMenuOpen(!profileMenuOpen);
    if (!profileMenuOpen) {
      document.body.classList.add("hide-cart");
    } else {
      document.body.classList.remove("hide-cart");
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (!menuOpen) {
      document.body.classList.add("overlay-open");
    } else {
      document.body.classList.remove("overlay-open");
    }
  };

  const openAuthModal = (mode) => {
    setAuthMode(mode);
    setAuthModalOpen(true);
    document.body.classList.add("hide-cart");
  };

  const closeAuthModal = () => {
    setAuthModalOpen(false);
    document.body.classList.remove("hide-cart");
  };

  return (
    <nav className="nav-bar">
      <div className="navbar-content">
        {isMobile ? (
          <>
            <div className="mobile-bottom-nav">
              <Link to="/" className="navbar-toggle">
                <img
                  src={require("../../assets/images/header-logo.png")}
                  alt="Home"
                  className="air-kitchenz-dark"
                  style={{ width: 54, height: 28, objectFit: "contain" }}
                />
                <span className="nav-label">Home</span>
              </Link>
              <button
                className="navbar-toggle"
                onClick={toggleMenu}
                style={{ background: "none", border: "none" }}
              >
                <img
                  src={require("../../assets/images/Bag-icon.png")}
                  alt="Explore"
                  style={{ width: 28, height: 28 }}
                />
                <span className="nav-label">Explore</span>
              </button>
              {!user && (
                <>
                  <button
                    className="navbar-toggle"
                    onClick={() => openAuthModal("login")}
                    style={{ background: "none", border: "none" }}
                  >
                    <img
                      src={require("../../assets/images/Profile-icon.png")}
                      alt="Login"
                      style={{ width: 28, height: 28, borderRadius: "50%" }}
                    />
                    <span className="nav-label">Login</span>
                  </button>
                  <button
                    className="navbar-toggle"
                    onClick={() => openAuthModal("signup")}
                    style={{ background: "none", border: "none" }}
                  >
                    <img
                      src={require("../../assets/images/Profile-icon.png")}
                      alt="Sign Up"
                      style={{ width: 28, height: 28, borderRadius: "50%" }}
                    />
                    <span className="nav-label">Sign Up</span>
                  </button>
                </>
              )}
              {user && (
                <>
                  <Link to="/profile/my-bookings" className="navbar-toggle">
                    <img
                      src={
                        require("../../assets/images/BookingIcon.svg").default
                      }
                      alt="Bookings"
                      style={{ width: 28, height: 28 }}
                    />
                    <span className="nav-label">Bookings</span>
                  </Link>
                  <Link to="/profile/messages" className="navbar-toggle">
                    <img
                      src={
                        require("../../assets/images/profile-messages.svg")
                          .default
                      }
                      alt="Messages"
                      style={{ width: 28, height: 28 }}
                    />
                    <span className="nav-label">Messages</span>
                  </Link>
                  <Link to="/profile" className="navbar-toggle">
                    <img
                      src={
                        user.profilePicture ||
                        require("../../assets/images/Profile-icon.png")
                      }
                      alt="Profile"
                      style={{ width: 28, height: 28, borderRadius: "50%" }}
                    />
                    <span className="nav-label">Profile</span>
                  </Link>
                </>
              )}
            </div>
            <div className={`mobile-overlay ${menuOpen ? "open" : ""}`}>
              <button className="close-btn" onClick={toggleMenu}>
                <AiOutlineClose size={30} />
              </button>
              <div className="overlay-content">
                <Link to="/list-your-kitchen" onClick={toggleMenu}>
                  Rent your kitchen
                </Link>
                {/* <Link to="/kitchenwaitinglist" onClick={toggleMenu}>
                  Join Waitlist
                </Link> */}
                <Link to="/aibuilder" onClick={toggleMenu}>
                  Chef tools
                </Link>
                <Link to="/faqs" onClick={toggleMenu}>
                  FAQs
                </Link>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="nav-left">
              <a href="/">
                <img
                  src={require("../../assets/images/header-logo.png")}
                  alt="Logo"
                  className="air-kitchenz-dark"
                />
              </a>
            </div>
            <div className="nav-center">
              <Link to="/list-your-kitchen" className="feature-links">
                Rent your kitchen
              </Link>
              {/* <Link to="/kitchenwaitinglist" className="feature-links">
                Join Waitlist
              </Link> */}
              <Link to="/faqs" className="feature-links">
                FAQs
              </Link>
            </div>
            <div className="nav-right">
              {user ? (
                <div
                  className="profile-container"
                  onMouseEnter={() => document.body.classList.add("hide-cart")}
                  onMouseLeave={() =>
                    document.body.classList.remove("hide-cart")
                  }
                >
                  <div className="profile-link">
                    <div className="profile-text">
                      <span className="greeting">Hi, {user.firstName}!</span>
                    </div>
                    <img
                      src={user.profilePicture || UserProfile}
                      alt={`${user.firstName}`}
                      className="navbar-profile-picture"
                    />
                  </div>
                  <div className="profile-dropdown">
                    <Link to="/profile/messages" className="dropdown-link">
                      <img
                        src={messages}
                        alt="Messages"
                        className="dropdown-icon"
                      />
                      Inbox
                    </Link>
                    <Link to="/profile" className="dropdown-link">
                      <img
                        src={dashboard}
                        alt="Profile"
                        className="dropdown-icon"
                      />
                      Profile Info
                    </Link>
                    <Link to="/profile/Favourites" className="dropdown-link">
                      <img
                        src={Favourite}
                        alt="Favourites"
                        className="dropdown-icon"
                      />
                      Favourites
                    </Link>
                    <Link to="/dashboard/today" className="dropdown-link">
                      <img
                        src={myKitchen}
                        alt="Manage Kitchens"
                        className="dropdown-icon"
                      />
                      Manage Kitchens
                    </Link>
                    <Link to="/profile/my-bookings" className="dropdown-link">
                      <img
                        src={booking}
                        alt="Bookings"
                        className="dropdown-icon"
                      />
                      Bookings
                    </Link>
                    <Link to="/profile/settings" className="dropdown-link">
                      <img
                        src={settings}
                        alt="Settings"
                        className="dropdown-icon"
                      />
                      Account Settings
                    </Link>
                    <Link
                      className="dropdown-link"
                      onClick={() => {
                        logout();
                        toggleProfileMenu();
                      }}
                    >
                      <img
                        src={Sign_Out}
                        alt="Logout"
                        className="dropdown-icon"
                      />
                      Logout
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="profile-icon">
                  <Button
                    variant="outlined"
                    className="auth-button auth-button-login"
                    onClick={() => openAuthModal("login")}
                  >
                    Login
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    className="auth-button auth-button-signup"
                    onClick={() => openAuthModal("signup")}
                  >
                    Sign Up
                  </Button>
                </div>
              )}
            </div>
          </>
        )}
      </div>
      <AuthModal
        open={authModalOpen}
        onClose={closeAuthModal}
        initialMode={authMode}
      />
    </nav>
  );
};

export default Navbar;
